import { Grid } from '@material-ui/core';
import AddressGrid from 'components/address-grid';
import Button from 'components/button';
import { Field, Form, Textarea } from 'components/forms';
import { signForm } from 'components/forms/decorators';
import NewOptionsSidebar from 'components/new-options-sidebar';
import NewProductPicker from 'components/new-product-picker';
import SectionBanner from 'components/section-banner';
import { autobind } from 'core-decorators';
import { reverse } from 'core/urls';
import { getDefaultAddress } from 'core/utils';
import createCLDealerTrialSignsOrderMutation from 'graphql/mutations/orders/create-cl-dealer-trial-signs.gql';
import React, { Component } from 'react';
import styles from '../../styles.css';

@signForm(createCLDealerTrialSignsOrderMutation, 'cl_dealer_trial_signs')
@autobind
export default class CLDealerTrialSignsCreate extends Component {
    render() {
        
        return (
            <div className={styles.root}>
                <SectionBanner />
                <NewOptionsSidebar
                    refundType='cl'
                    userType='dealer'
                    links={['refund', 'kits', 'trialSigns']}
                />
            <p className={styles.title}>Pedido de carteles</p>
            <p className={styles.subtitle}>Seleccioná los carteles para estacas que necesites para tu campo líder en
                                        función de lo que sembraste y la cantidad de bolsas que te fueron entregadas.</p>
                   
                    <div className={styles.formContainer}>
                        <Form
                            fields={[
                                {key: 'items', initial: []}, 
                                {key: 'notes', required: false},
                                {
                                    key: 'address',
                                    initial: getDefaultAddress(this.props.addressesData),
                                },
                            ]}
                            errors={this.props.errors}
                            onSubmit={this.props.onSubmit}>
                            {({getFieldProps, renderErrors, isValid, values}) => (
                            <Grid container direction='column' spacing={2}>
                                <Grid item>
                                    <Field>
                                        <NewProductPicker
                                            items={this.props.itemsData.signs}
                                            perItemLimit={this.props.itemsData.perItemLimit}
                                            toggleSelectedProduct={this.props.toggleSelectedProduct}
                                            {...getFieldProps('items')}
                                        />
                                        {renderErrors('items')}
                                    </Field>
                                </Grid>
                                <Grid item>
                                    <Field label='Comentarios para Nidera'>
                                        <Textarea {...getFieldProps('notes')} />
                                        {renderErrors('notes')}
                                    </Field>
                                </Grid>
                                <Grid item>
                                    <Field label='Dirección de envío de los carteles'>
                                        <AddressGrid
                                            addresses={this.props.addressesData.addresses}
                                            returnUrl={reverse('clDealerTrialSignsCreate')}
                                            returnData={values}
                                            {...getFieldProps('address')}
                                        />
                                        {renderErrors('address')}
                                    </Field>
                                </Grid>
                                <Grid item>
                                    {renderErrors('__all__')}
                                </Grid>
                                <Grid item>
                                    <Form.Actions>
                                            <Grid container justify='flex-end'>
                                                <Grid item xs={4}>
                                                <Button fullWidth theme='yellow' disabled={!isValid() || this.props.loading}>
                                                    {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                                </Button>
                                                </Grid>
                                            </Grid>
                                    </Form.Actions>
                                </Grid>
                                </Grid>
                            )}
                        </Form>
                    </div>
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/cl-dealer/trial-signs/create/index.js